import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/doubleQuotes.png'


const _withScopeId = n => (_pushScopeId("data-v-66949a90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "farming_recommmend" }
const _hoisted_2 = { id: "farming_content" }
const _hoisted_3 = ["data-aos-delay"]
const _hoisted_4 = { id: "farming_box_theme" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { id: "farming_box_title" }
const _hoisted_7 = { id: "farming_des_box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "farming_des_icon",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          id: "farming_box",
          key: item.theme,
          "data-aos": "zoom-in",
          "data-aos-duration": "800",
          "data-aos-delay": index * 200
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(item.theme), 1),
          _createElementVNode("img", {
            id: "farming_box_img",
            src: item.img
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.des, (desContent, index) => {
              return (_openBlock(), _createElementBlock("span", {
                id: "farming_des_span",
                key: index
              }, _toDisplayString(desContent), 1))
            }), 128))
          ])
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}